// extracted by mini-css-extract-plugin
module.exports = {"flyoutMenuItem":"FlyoutMenuItem-flyoutMenuItem--3425c"};